'use strict';

// import debug from 'debug';
import { createApp, markRaw } from 'vue';
import 'regenerator-runtime';
import { createPinia, PiniaPlugin, PiniaPluginContext } from 'pinia';
import 'moment';
import 'moment-timezone';
import 'chartjs-adapter-moment';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import '../scss/styles.scss';
import router from './router';
import i18n from '~/i18n';
import chartJs from './chart-js';

import geocoder from '~/plugins/geocoder/geocoder.plugins';
import geolocalization from '~/plugins/geolocalization.plugins';
import prompt from '~/plugins/prompt.plugin';
import eventBus from '~/plugins/mitt.plugins';
import errorHandler from '~/core/error-handler';
import notifier from '~/core/notifier';

import App from './app.vue';
import { AuthService } from './api/services/auth.service';
import { StationService } from './api/services/station.service';
import { WeatherService } from './api/services/weather.service';
import http from './api/api-http';
import { useConfigStore } from './store/configuration.store';

const app = createApp(App);

chartJs();

app.use(router);

app.use(prompt);

app.use(geocoder);
app.use(geolocalization);

import 'leaflet/dist/leaflet.css';
import { DashboardService } from './api/services/dashboard.service';

// App.component('l-map', LMap);
// App.component('l-tile-layer', LTileLayer);
// App.component('l-marker', LMarker);


const piniaPlugin: PiniaPlugin = (context: PiniaPluginContext) => {
    context.store.$authService = markRaw(AuthService.getInstance());
    context.store.$stationService = markRaw(StationService.getInstance());
    context.store.$weatherService = markRaw(WeatherService.getInstance());
    context.store.$dashboardService = markRaw(DashboardService.getInstance());
}

app.use(
    createPinia()
        .use(piniaPlugin)
        .use(({ store }) => {
            store.$router = markRaw(router);
        })
);

app.use(http)
app.use(i18n);
app.use(eventBus);
app.use(errorHandler);
app.use(notifier);

const configuration = useConfigStore();
if(!configuration.loaded) {
    configuration.load();
}

// @ts-ignore
if(configuration?.environment == 'prod') {
    Sentry.init({
        app,
        //@ts-ignore
        environment: configuration?.environment || 'production',
        dsn: "https://1b17f8f06b4c4d80a2a3381116c3cd0a@o4503998855970816.ingest.sentry.io/4504916173127680",
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ["localhost", "avolta-connect.elichens.com", "avolta-connect-test.elichens.com", /^\//],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        release: configuration?.VERSION
    });
}


app.mount('#app');
